import React from "react";
import { Text, View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";

export interface TimeUnitDisplayProps {
    /**
     * The number to be displayed.
     */
    numeral: number;
    /**
     * The unit of time measurement to be displayed.
     */
    unit: string;
}

const TimeUnitDisplay: React.FC<TimeUnitDisplayProps> = ({ numeral = 3, unit = "Hours" }) => {
    const styles = useDynamicStyles(calculateStyles);
    return (
        <View style={styles.container}>
            <View style={styles.timeContainer}>
                <Text style={styles.time}>{numeral}</Text>
            </View>
            <View style={styles.descriptorContainer}>
                <Text style={styles.descriptor}>{unit.toLocaleUpperCase()}</Text>
            </View>
        </View>
    );
};
export default TimeUnitDisplay;

const calculateStyles = () => {
    return EStyleSheet.create({
        container: {
            height: 60,
            width: 60,
            margin: 2.5,
            justifyContent: "center",
            alignItems: "center",
        },
        time: {
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
            color: () => EStyleSheet.value(GlobalStyles.TIME_TEXT),
            fontSize: 32,
            lineHeight: 32,
            marginTop: 6,
        },
        descriptor: {
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
            color: () => EStyleSheet.value(GlobalStyles.TIME_DESCRIPTOR_TEXT),
            fontSize: 16,
            lineHeight: 16,
            marginTop: 2,
        },
        timeContainer: {
            width: "100%",
            height: 40,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.TIME_BACKGROUND),
            borderTopLeftRadius: () => EStyleSheet.value(GlobalStyles.TIME_BORDER_RADIUS),
            borderTopRightRadius: () => EStyleSheet.value(GlobalStyles.TIME_BORDER_RADIUS),
            justifyContent: "center",
            alignItems: "center",
        },
        descriptorContainer: {
            width: "100%",
            height: 22,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.TIME_DESCRIPTOR),
            borderBottomLeftRadius: () => EStyleSheet.value(GlobalStyles.TIME_BORDER_RADIUS),
            borderBottomRightRadius: () => EStyleSheet.value(GlobalStyles.TIME_BORDER_RADIUS),
            justifyContent: "center",
            alignItems: "center",
        },
    });
};
